/** Visual marker in the chat showing where an in-place context reset occurred.
 *  Messages above this line are excluded from the AI context window.
 *  Messages below (and the divider itself) are included.
 */
export function ContextResetDivider({ isoTimestamp }: { isoTimestamp: string }) {
  const d = new Date(isoTimestamp);
  const label = isNaN(d.getTime())
    ? 'Context reset'
    : d.toLocaleString([], {
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });

  return (
    <div class="context-reset-divider" title="Messages above this line are not sent to the AI">
      <span class="context-reset-divider__line" />
      <span class="context-reset-divider__label">
        <span class="context-reset-divider__above">↑ Not in context</span>
        <span class="context-reset-divider__dot">·</span>
        <span class="context-reset-divider__time">Reset {label}</span>
        <span class="context-reset-divider__dot">·</span>
        <span class="context-reset-divider__below">In context ↓</span>
      </span>
      <span class="context-reset-divider__line" />
    </div>
  );
}
